import { UserStoreStatistics } from "../../../models/Statistics";

export const REQUEST_USERSTATISTICS_FOR_STORE =
  "REQUEST_USERSTATISTICS_FOR_STORE";
export const REQUEST_USERSTATISTICS_FOR_STORE_DONE =
  "REQUEST_USERSTATISTICS_FOR_STORE_DONE";

export interface FetchUserStatisticsForStore {
  type: typeof REQUEST_USERSTATISTICS_FOR_STORE;
  payload: ReadonlyArray<UserStoreStatistics>;
}

export interface FetchUserStatisticsForStoreDone {
  type: typeof REQUEST_USERSTATISTICS_FOR_STORE_DONE;
  payload: ReadonlyArray<UserStoreStatistics>;
}

export interface UserStoreStatisticsState {
  isLoading: boolean;
  userStoreStatistics: ReadonlyArray<UserStoreStatistics>;
}

export type UserStatisticsActions =
  | FetchUserStatisticsForStore
  | FetchUserStatisticsForStoreDone;
